import { render, staticRenderFns } from "./DeleteOfferPopup.vue?vue&type=template&id=5d5df1c1&scoped=true&"
import script from "./DeleteOfferPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteOfferPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteOfferPopup.vue?vue&type=style&index=0&id=5d5df1c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5df1c1",
  null
  
)

export default component.exports